module.exports = __webpack_public_path__ + "img/38731-017.fa22af25.jpg";